import { DATE_FORMAT_WEEK_DAY_SHORT_FNS, WeekdayEnum } from '@schooly/api';
import { DayPickerOption } from '@schooly/style';
import { startOfWeek, eachDayOfInterval, addDays, format, getDate, isWeekend } from 'date-fns';
import { WEEKDAY_TO_DAY_INDEX } from '../../../School/SchoolTimetableStructures/utils';

export function getWeekDays(date: Date): DayPickerOption<Date>[] {
  const start = startOfWeek(date, { weekStartsOn: 1 });
  const end = addDays(start, 6);

  return eachDayOfInterval({ start, end }).map((d) => ({
    value: d,
    topLabel: format(d, DATE_FORMAT_WEEK_DAY_SHORT_FNS),
    label: String(getDate(d)),
    variant: isWeekend(d) ? 'red' : 'default',
  }));
}

export function isStructureActiveDay(structureWeekdays: WeekdayEnum[], date: Date): boolean {
  if (!structureWeekdays.length) return false;
  const activeDaysNumbers = structureWeekdays.map((weekday) => WEEKDAY_TO_DAY_INDEX[weekday]);
  return activeDaysNumbers.includes(date.getDay());
}
